'use client';

import classNames from 'classnames';
import { CasesRevealingBlock, IImage } from '@sapientpro/sapientpro-data-models';
import { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import styles from './CaseRevealingPoints.module.scss';
import Img from '../../../../components/Img';
import CaseRevealingPointItem from './CaseRevealingPointItem';
import DynamicHeading from '../../../../components/DynamicHeading';
import { Theme, theme } from '../../../../store/theme';

const CaseRevealingPoints = ({ data }: { data: CasesRevealingBlock }) => {
  const appTheme = useAtomValue(theme);
  const firstItemId = data.points?.[0];
  const [activeItemId, setActiveItemId] = useState<number>(firstItemId?.id);
  const [blockImage, setBlockImage] = useState<IImage>(data.image);

  const updateBlockImage = (pointId?: number) => {
    const currentItemId = pointId || activeItemId;

    if (currentItemId) {
      const currentPoint = data.points?.find(({ id }) => id === currentItemId);
      const darkImage = currentPoint?.darkMedia || currentPoint?.lightMedia;
      const lightImage = currentPoint?.lightMedia || currentPoint?.darkMedia;
      const pointImage = appTheme === Theme.DARK ? darkImage : lightImage;
      setBlockImage(pointImage || data.image);
    }
  };

  const handleActiveChange = (newId: number) => {
    if (newId !== activeItemId) {
      setActiveItemId(newId);
      updateBlockImage(newId);
    }
  };

  useEffect(() => {
    updateBlockImage();
  }, [appTheme]);

  return (
    <section className={classNames(styles.revealingPoints, 'container')}>
      <DynamicHeading
        headingTag={data.topHeading}
        className={styles.revealingPointsTitle}
      >
        {data.title}
      </DynamicHeading>
      <div
        className={classNames(styles.revealingPointsContent, {
          [styles.reversedOrder]: data.alignment === 'right',
        })}
      >
        {!!blockImage && (
        <Img
          key={blockImage.id}
          src={blockImage.url}
          width={blockImage.width}
          height={blockImage.height}
          alt={blockImage.alternativeText || 'revealing points image'}
          className={styles.pointsImage}
        />
        )}
        <div className={styles.points}>
          {
        data.points.map((point) => {
          const isActive = activeItemId === point.id;

          return (
            <>
              <CaseRevealingPointItem
                key={point.id}
                data={point}
                headingTag={data.topHeading}
                onStateChange={() => handleActiveChange(point.id)}
                isActive={activeItemId === point.id}
              />
              {isActive && (
              <Img
                key='points_image'
                src={blockImage.url}
                width={blockImage.width}
                height={blockImage.height}
                alt={blockImage.alternativeText || 'revealing points image'}
                className={styles.pointsImage}
              />
              )}
            </>
          );
        })
      }
        </div>
      </div>
    </section>
  );
};

export default CaseRevealingPoints;
